module.exports = __webpack_public_path__ + "media/components/riskregister/icon-vectors/equipment-c1ca00e3396e2e519898b5a8ee7c87e3.png";